import request from '@/utils/request'
// 查询统计数据分页
export function pageAdSeries(query) {
    return request({
        url: '/user/ad-statistics/video-ad-statistics',
        method: 'get',
        params: query
    })
}

export function fetchAdDetailByGatherId (query) {
    return request({
        url: '/user/ad-statistics/video-ad-statistics-detail',
        method: 'get',
        params: query
    })
}

export function adWelfateStatistics(query) {
    return request({
        url: '/user/ad-statistics/task-ad-statistics',
        method: 'get',
        params: query
    })
}

export function fetchAdWelfateDetail (query) {
    return request({
        url: '/user/ad-statistics/task-ad-statistics-detail',
        method: 'get',
        params: query
    })
}
